module.exports = __webpack_public_path__ + "img/3.93be8017.svg";